import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, trackAdsConversion } from '../utils/analytics';
import SocialLinks from './SocialLinks';

export default function Footer() {
  const handleWhatsAppClick = () => {
    trackEvent('whatsapp_click', { location: 'footer' });
    trackAdsConversion(process.env.REACT_APP_GADS_CONVERSION_LABEL_WHATSAPP);
  };

  return (
    <footer className="bg-zinc-50 border-t border-zinc-200 mt-auto">
      <div className="max-w-container mx-auto px-6 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Brand */}
        <div className="space-y-4">
          <div className="text-lg font-bold text-primary font-serif">Scorpion Golf Cart Rental</div>
          <p className="text-zinc-500 text-sm leading-relaxed">
            Golf cart rentals in San Pedro, Ambergris Caye, Belize. Choose a cart for your group and arrange delivery to your accommodation.
          </p>
          <p className="text-xs text-zinc-400">
            Built by{' '}
            <a
              href="https://www.instagram.com/jaf_aurion"
              target="_blank"
              rel="noreferrer"
              className="font-semibold hover:underline transition-colors"
            >
              <span style={{ color: '#1a2a6c' }}>JAF</span>-AURION
            </a>
          </p>
        </div>

        {/* Navigation */}
        <div className="flex flex-col space-y-3">
          <h4 className="font-bold text-primary font-serif text-sm uppercase tracking-wider">Navigation</h4>
          <Link to="/" className="text-zinc-500 hover:text-primary transition-colors text-sm">Home</Link>
          <Link to="/cars" className="text-zinc-500 hover:text-primary transition-colors text-sm">Our Fleet</Link>
          <Link to="/about" className="text-zinc-500 hover:text-primary transition-colors text-sm">About Us</Link>
          <Link to="/san-pedro-golf-cart-rental-guide" className="text-zinc-500 hover:text-primary transition-colors text-sm">San Pedro Rental Guide</Link>
          <Link to="/contact" className="text-zinc-500 hover:text-primary transition-colors text-sm">Contact & Delivery</Link>
        </div>

        {/* Contact */}
        <div className="space-y-4">
          <h4 className="font-bold text-primary font-serif text-sm uppercase tracking-wider">Contact</h4>
          <a
            href="https://wa.me/5016007672?text=Hi%20I%20am%20interested%20in%20renting%20a%20golf%20car"
            target="_blank"
            rel="noreferrer"
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-2 bg-[#25D366] text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-[#1ebe5d] transition-colors"
          >
            <span className="material-symbols-outlined text-[18px]">chat</span>
            WhatsApp Us
          </a>
          <address className="not-italic text-zinc-500 text-sm space-y-2"><p>San Pedro, Ambergris Caye, Belize</p><a href="tel:+5016007672" onClick={() => trackEvent('phone_click', { location: 'footer' })} className="hover:underline">+501 600-7672</a></address>
          <p className="text-zinc-400 text-xs">Available daily 8am – 10pm (Belize time)</p>
          <div className="pt-1">
            <p className="text-xs font-semibold text-zinc-400 uppercase tracking-wider mb-2">Follow Us</p>
            <SocialLinks />
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-200 py-4 text-center text-xs text-zinc-400">
        © {new Date().getFullYear()} Scorpion Golf Cart Rental. All rights reserved.
      </div>
    </footer>
  );
}
